<script setup lang="ts">
import { computed } from 'vue'

import type { ToastViewportProps } from '@fondof-ui/components/toast/types'
import { toastViewportVariants } from '@fondof-ui/components/toast/variants'
import { useIsScreenMd } from '@shared/fondof-fn/media-query/screen'
import { ToastViewport } from 'radix-vue'

const props = defineProps<ToastViewportProps>()

const isScreenMd = useIsScreenMd()

const position = computed(() => {
  if (typeof props.position === 'string') {
    return props.position
  }

  if (props.position?.desktop && isScreenMd.value) {
    return props.position.desktop
  }

  if (props.position?.mobile && !isScreenMd.value) {
    return props.position.mobile
  }

  return 'top-center'
})
</script>

<template>
  <ToastViewport
    :class="
      toastViewportVariants({
        position,
      })
    "
  />
</template>
